export enum TaskMessageType {
    FIRST                   = 1,
    MESSAGE                 = 2,
    NO_REPLY                = 3,
    
    STATUS_UPDATE_REQUEST   = 4,
    
    REASSIGN                = 10,// manual reassing
    
    PRIORITY                = 11,
    SET_DEADLINE            = 12,
    CHANGE_DEADLINE         = 13,
    REMOVE_DEADLINE         = 14,
    ESTIMATE                = 15,
    MOVE                    = 16,
    AUTO_REASSIGN           = 17,// auto reassign
    
    TIME_REPORT             = 18,
    AR_CHANGE               = 19,
    
    SCHEDULE_DATE           = 20,
    SCHEDULE_SOMEDAY        = 21,
    START_END               = 22,
    
    VIEW                    = 30,
    ADD_USER                = 31
}
